import Head from 'next/head'

type HeadProps = {
  title?: string
  ogTitleList?: string[]
  content?: string
  ldJsonSchema?: LdJsonSchema
  canonicalLink?: string
  ogDescription?: string
  ogImage?: string
  ogUrl?: string
  ogType?: string
}

const HeadComponent: React.FC<HeadProps> = ({
  title,
  ogTitleList,
  content,
  canonicalLink,
  ldJsonSchema,
  ogDescription,
  ogImage,
  ogUrl,
  ogType,
  children,
}) => {
  const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

  const metaTags = ogTitleList
    ? ogTitleList.map((og) => (
        <meta property="og:title" content={og} key={og} />
      ))
    : null

  return (
    <>
      <Head>
        {metaTags && metaTags}
        {title && <title>{title}</title>}
        {content && <meta name="description" content={content} />}
        {ogDescription && (
          <meta property="og:description" content={ogDescription} />
        )}
        {ogImage && <meta property="og:image" content={ogImage} />}
        {ogUrl && <meta property="og:url" content={ogUrl} />}
        {ogType && <meta property="og:type" content={ogType} />}
        {!isProduction && <meta name="robots" content="noindex, nofollow" />}
        {canonicalLink && (
          <link rel="canonical" href={canonicalLink.toLowerCase()} />
        )}
        {ldJsonSchema &&
          // add multiple ldJsonSchemas
          (Array.isArray(ldJsonSchema) ? (
            ldJsonSchema.map((schema, index) => (
              <script
                key={index}
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
              />
            ))
          ) : (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJsonSchema) }}
            />
          ))}
      </Head>
      {children}
    </>
  )
}

export default HeadComponent
